/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.redeemAmazonCatalogueItem

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.redeemAmazonCatalogueItem.RedeemAmazonCatalogueItemsApi
import features.redeemAmazonCatalogueItem.models.RedeemResponseModel
import features.redeemAmazonCatalogueItem.serializeRedeemAmazonCatalogueItemsState
import features.redeemAmazonCatalogueItem.models.RedeemAmazonItemRequest

import kotlinx.serialization.decodeFromString

/**
 * Redeem an Amazon catalogue item.  [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("RedeemAmazonCatalogueItemsApi")
class RedeemAmazonCatalogueItemsApiJs {

    /**
     * Redeem an Amazon catalogue item. 
     */


    
    fun redeemAmazonCatalogueItem(overrideHeaders: String?,
serializedRedeemAmazonItemRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = RedeemAmazonCatalogueItemsApi().redeemAmazonCatalogueItem(
            overrideHeaders = decodedOverrideHeaders,
                redeemAmazonItemRequest = Json.decodeFromString(
                    serializedRedeemAmazonItemRequest
                )
            ).toJsonResult<RedeemResponseModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeRedeemAmazonCatalogueItemsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        RedeemAmazonCatalogueItemsApi().redeemAmazonCatalogueItemsState.serializeRedeemAmazonCatalogueItemsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
